import React from 'react';
import PropTypes from 'prop-types';
import Amount from 'sharedWebpack/Amount';
import { Link } from 'react-router-dom';
import Button from '@wtag/rcl-button';
import classNames from 'classnames';
import searchURL from '../../../lib/helpers/searchURL';
import './styles.scss';

const ExchangeMatrixHeader = ({ currency, searchId, price }) => (
  <div className="d-flex align-center justify-space-between flex-wrap exchange-matrix-header">
    <div className="exchange-matrix-header__title">
      {I18n.t('components.ibe.results.exchange_matrix_title')}
    </div>
    <div className="d-flex align-center column-gap-16 flex-wrap">
      <div className="exchange-matrix-header__price">
        <span className="exchange-matrix-header__price-label">
          {I18n.t('components.ibe.results.total_price')}
        </span>
        <Amount
          className={classNames('exchange-matrix-header__price-amount', {
            'exchange-matrix-header__price--zero': !price,
          })}
          currency={currency}
          value={price}
        />
      </div>
      <Link to={searchURL('flight', searchId)}>
        <Button size="small" label={I18n.t('components.ibe.results.back_to_result')} />
      </Link>
    </div>
  </div>
);

ExchangeMatrixHeader.propTypes = {
  currency: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  searchId: PropTypes.string.isRequired,
};

export default ExchangeMatrixHeader;
